import { FC } from 'react';
import { Switch } from '@headlessui/react';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';

interface InsuranceSwitchProps {
  isChecked: boolean;
  isLoading: boolean;
  onChange: () => void;
  isBlurSwitch?: boolean;
}

const InsuranceSwitch: FC<InsuranceSwitchProps> = ({
  isChecked,
  isLoading,
  onChange,
  isBlurSwitch,
}) => {
  return (
    <div className="flex gap-x-0.8 items-center mr-[20px]">
      <Switch checked={isChecked} onChange={onChange}>
        <div
          className={`${
            isChecked
              ? `bg-magenta ${isBlurSwitch ? 'opacity-50' : ''}`
              : 'bg-[#78788029]'
          } relative inline-flex h-3.1 w-5.1 items-center rounded-full ${
            isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
          } transition-colors duration-200`}
        >
          <span
            className={`${
              isChecked ? 'translate-x-[2.3rem]' : 'translate-x-[2px]'
            } inline-block h-2.5 w-2.5 transform rounded-full transition bg-white`}
          />
        </div>
      </Switch>
      {isLoading && (
        <div className="h-3.1 pl-1 flex items-center">
          <LoadingSpinner className="all-child:fill-magenta w-2 h-2 opacity-50" />
        </div>
      )}{' '}
    </div>
  );
};

export default InsuranceSwitch;
